const editorActions = {
    SET_FALLBACK_ENTITY: 'SET_FALLBACK_ENTITY',
    SET_EDITOR_STATE: 'SET_EDITOR_STATE',
};

export default editorActions;
